__turbopack_context__.v({
  "reference": "Yl5EcG_reference",
});
